export const api_key = "CNCPjPwgEVyXIw5sA8l";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-demo-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk-demo.carenow.healthcare");
